import React from "react";


// 
// 
const CustomTimeSelectButton = (props) => {


    return(
        <button type="button" className={`py-2 px-3 rounded border text-base text-center w-[70px] hover:bg-gray-100 ${props.isSelected ? 'bg-primary border-primary text-white hover:bg-primary' : ''}`} onClick={(e)=> props.onChange(e) }>{props.title}</button>
    )
}

export default CustomTimeSelectButton